(() => {
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const lock=(yes)=>document.documentElement.style.overflow=yes?'hidden':'';
  const esc=(v='')=>String(v).replace(/[&<>'\"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','\"':'&quot;'}[m]));
  function overlay(open){const o=$('#fl4-overlay');if(o)o.classList.toggle('is-open',open);lock(open)}
  function closeAll(){['#fl4-menu','#fl4-cart','#fl4-search'].forEach(s=>$(s)?.classList.remove('is-open'));$('.fl4-hamburger')?.setAttribute('aria-expanded','false');overlay(false)}
  window.fl4CloseAll=closeAll;
  window.fl4OpenMenu=()=>{closeAll();$('#fl4-menu')?.classList.add('is-open');$('.fl4-hamburger')?.setAttribute('aria-expanded','true');overlay(true)};
  window.fl4OpenSearch=()=>{closeAll();$('#fl4-search')?.classList.add('is-open');overlay(true);setTimeout(()=>$('#fl4-search input')?.focus(),200)};
  window.fl4OpenCart=async()=>{closeAll();$('#fl4-cart')?.classList.add('is-open');overlay(true);await renderCart();$('#fl4-cart [data-fl4-close]')?.focus()};
  let cartRequest = 0;
  async function renderCart() {
    const drawer = $('#fl4-cart');
    if (!drawer) return;
    const request = ++cartRequest;
    drawer.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + '?section_id=fl4-cart-content', {headers:{Accept:'text/html'}, cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = parsed.querySelector('#shopify-section-fl4-cart-content');
      if (!content || request !== cartRequest) return;
      drawer.innerHTML = content.innerHTML;
      const count = Number($('#fl4-cart-body',drawer)?.dataset.cartCount || 0);
      $$('.fl4-cart-count').forEach(x=>x.textContent=count);
      drawer.querySelector('[data-fl4-close]')?.addEventListener('click',closeAll);
      $$('[data-cart-key]',drawer).forEach(button=>button.addEventListener('click',async()=>{
        if(drawer.getAttribute('aria-busy') === 'true') return;
        drawer.setAttribute('aria-busy','true');
        const buttons=$$('[data-cart-key]',drawer);buttons.forEach(b=>b.disabled=true);
        try {
          const result=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:button.dataset.cartKey,quantity:Number(button.dataset.cartQuantity)})});
          const data=await result.json();
          if(!result.ok) throw new Error(data.description || window.fl4CartError);
          await renderCart();
          const replacement=$$('[data-cart-key]',drawer).find(b=>b.dataset.cartKey===button.dataset.cartKey && b.textContent===button.textContent);
          replacement?.focus();
        } catch(error) {alert(error.message || window.fl4CartError);}
        finally {drawer.removeAttribute('aria-busy');buttons.forEach(b=>b.disabled=false);}
      }));
    } catch(error) {
      alert(window.fl4CartError || 'Could not load cart. Please try again.');
    } finally {if(request===cartRequest) drawer.removeAttribute('aria-busy');}
  }
  function formatMoney(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.fl4Currency||'EUR'}).format(cents/100)}catch(e){return '€'+(cents/100).toFixed(2)}}
  window.fl4Slide=(id,dir)=>{const el=document.getElementById(id);if(el)el.scrollBy({left:dir*el.clientWidth*.82,behavior:'smooth'})};
  window.fl4OpenFilters=()=>{const d=$('#fl4-filter-drawer');if(d){d.classList.add('is-open');overlay(true)}};
  window.fl4CloseFilters=()=>{$('#fl4-filter-drawer')?.classList.remove('is-open');overlay(false)};
  function ordinal(n){const n100=n%100;if(n100>=11&&n100<=13)return'th';if(n%10===1)return'st';if(n%10===2)return'nd';if(n%10===3)return'rd';return'th'}
  function dateLabel(d){const month=d.toLocaleDateString('en',{month:'short'});const day=d.getDate();return `${month} ${day}${ordinal(day)}`}
  function dateRangeLabel(start,end){const sm=start.toLocaleDateString('en',{month:'short'}),em=end.toLocaleDateString('en',{month:'short'}),sd=start.getDate(),ed=end.getDate();if(sm===em)return `${sm} ${sd}${ordinal(sd)} – ${ed}${ordinal(ed)}`;return `${sm} ${sd}${ordinal(sd)} – ${em} ${ed}${ordinal(ed)}`}
  function setDeliveryDates(){const now=new Date();$$('[data-fl4-date="today"]').forEach(x=>x.textContent=dateLabel(now));const readyStart=new Date(now),readyEnd=new Date(now);readyStart.setDate(readyStart.getDate()+1);readyEnd.setDate(readyEnd.getDate()+2);$$('[data-fl4-date="ready"]').forEach(x=>x.textContent=dateRangeLabel(readyStart,readyEnd));const deliveryStart=new Date(readyStart),deliveryEnd=new Date(readyEnd);deliveryStart.setDate(deliveryStart.getDate()+10);deliveryEnd.setDate(deliveryEnd.getDate()+12);$$('[data-fl4-date="delivery"]').forEach(x=>x.textContent=dateRangeLabel(deliveryStart,deliveryEnd))}

  function updateVariantUI(input){const form=input.closest('form');const hidden=$('input[name="id"]',form);if(hidden)hidden.value=input.value;const price=$('[data-fl4-product-price]');const compare=$('[data-fl4-product-compare]');const save=$('[data-fl4-save]');const stock=$('[data-fl4-stock]');const selected=$('[data-fl4-selected-size]');const add=$('.fl4-add',form);const buy=$('[data-fl4-buy-now]',form);const shopPay=$('.fl4-shop-pay',form);const available=input.dataset.available==='true';if(price)price.textContent=input.dataset.price||'';if(compare){compare.textContent=input.dataset.compare||'';compare.classList.toggle('is-hidden',!input.dataset.compare)}if(save){save.textContent=input.dataset.save?`SAVE ${input.dataset.save}`:'';save.classList.toggle('is-hidden',!input.dataset.save)}if(selected)selected.textContent=input.dataset.title||'';if(stock){stock.textContent=available?'In stock':'Sold out';stock.classList.toggle('is-sold',!available)}if(add){add.disabled=!available;add.textContent=available?`Add to cart • ${input.dataset.price}`:'Sold out'}if(buy)buy.disabled=!available;if(shopPay)shopPay.classList.toggle('is-disabled',!available);if(input.dataset.mediaId)document.dispatchEvent(new CustomEvent('fl4:select-media',{detail:input.dataset.mediaId}))}
  function refreshActionFromChecked(form){const checked=$('.fl4-variant-input:checked',form);if(checked)updateVariantUI(checked)}
  async function addProduct(form,buyNow=false){const button=$('.fl4-add',form);if(button){button.disabled=true;button.textContent='Adding…'}try{const fd=new FormData(form);const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});if(!res.ok)throw new Error('add failed');if(buyNow){location.href='/checkout';return}await window.fl4OpenCart()}catch(e){alert('Please select an available size and try again.')}finally{if(button)refreshActionFromChecked(form)}}
  document.addEventListener('keydown',event=>{if(!$('#fl4-cart')?.classList.contains('is-open'))return;if(event.key==='Escape'){closeAll();document.querySelector('[onclick="fl4OpenCart()"]')?.focus()}if(event.key==='Tab'){const elements=$('a[href],button:not(:disabled),input:not(:disabled)', $('#fl4-cart'));const first=elements[0],last=elements[elements.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus()}}});
  document.addEventListener('DOMContentLoaded',()=>{
    $('#fl4-overlay')?.addEventListener('click',()=>{closeAll();window.fl4CloseFilters()});
    $$('[data-fl4-close]').forEach(b=>b.addEventListener('click',closeAll));
    $$('.fl4-variant-input').forEach(r=>r.addEventListener('change',()=>updateVariantUI(r)));
    $$('.fl4-qty').forEach(q=>{const input=$('input',q);$$('button',q).forEach(b=>b.addEventListener('click',()=>{const delta=Number(b.dataset.delta);input.value=Math.max(1,Number(input.value||1)+delta)}))});
    $$('.fl4-product-form').forEach(form=>{form.addEventListener('submit',e=>{e.preventDefault();addProduct(form,false)});$('[data-fl4-buy-now]',form)?.addEventListener('click',()=>addProduct(form,true))});
    $('[data-fl4-size-open]')?.addEventListener('click',()=>$('#fl4-size-modal')?.classList.add('is-open'));$$('[data-fl4-size-close]').forEach(x=>x.addEventListener('click',()=>$('#fl4-size-modal')?.classList.remove('is-open')));
    $$('.fl4-sort-select').forEach(s=>s.addEventListener('change',()=>s.form.submit()));
    setDeliveryDates();
  });
})();

/* FL4WLESS Add to cart click wipe */
(() => {
  const STYLE_ID = 'fl4-cart-click-effect-style';
  const ANIM_CLASS = 'is-fl4-cart-animating';
  const DURATION = 1100;

  function installStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .template-product .fl4-product-actions .fl4-add {
        background-color: #111 !important;
        background-image: linear-gradient(#fff, #fff) !important;
        background-repeat: no-repeat !important;
        background-position: left center !important;
        background-size: 0% 100% !important;
        border: 1px solid #111 !important;
        color: #fff !important;
      }

      .template-product .fl4-product-actions .fl4-add.${ANIM_CLASS} {
        animation: fl4CartClickWipe 1.1s cubic-bezier(.65, 0, .35, 1) both !important;
      }

      @keyframes fl4CartClickWipe {
        0% {
          background-size: 0% 100%;
          background-position: left center;
          color: #fff;
        }
        30% {
          background-size: 100% 100%;
          background-position: left center;
          color: #111;
        }
        68% {
          background-size: 100% 100%;
          background-position: left center;
          color: #111;
        }
        69% {
          background-size: 100% 100%;
          background-position: right center;
          color: #111;
        }
        100% {
          background-size: 0% 100%;
          background-position: right center;
          color: #fff;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .template-product .fl4-product-actions .fl4-add.${ANIM_CLASS} {
          animation-duration: .15s !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const forms = Array.from(document.querySelectorAll('.fl4-product-form'));
    if (!forms.length) return;

    installStyle();

    forms.forEach((form) => {
      const button = form.querySelector('.fl4-add');
      if (!button) return;

      button.addEventListener('click', (event) => {
        if (button.disabled || button.classList.contains(ANIM_CLASS)) return;

        event.preventDefault();
        button.classList.remove(ANIM_CLASS);
        void button.offsetWidth;
        button.classList.add(ANIM_CLASS);
        button.setAttribute('aria-busy', 'true');

        window.setTimeout(() => {
          button.classList.remove(ANIM_CLASS);
          button.removeAttribute('aria-busy');

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(button);
          } else {
            const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
            form.dispatchEvent(submitEvent);
          }
        }, DURATION);
      }, true);
    });
  });
})();

/* FL4WLESS dual-edge hover override */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('fl4-dual-edge-hover-style')) return;
    const style = document.createElement('style');
    style.id = 'fl4-dual-edge-hover-style';
    style.textContent = `
      @media (hover: hover) and (pointer: fine) {
        .template-product .fl4-product-actions .fl4-add:not(:disabled) {
          background-color: #111 !important;
          background-image: linear-gradient(#fff,#fff), linear-gradient(#fff,#fff) !important;
          background-repeat: no-repeat, no-repeat !important;
          background-position: left center, right center !important;
          background-size: 0% 100%, 0% 100% !important;
          color: #fff !important;
          border: 1px solid #111 !important;
          transition: background-size .42s cubic-bezier(.65,0,.35,1), color .16s ease !important;
        }

        .template-product .fl4-product-actions .fl4-add:not(:disabled):hover {
          background-size: 50.5% 100%, 50.5% 100% !important;
          color: #111 !important;
        }
      }
    `;
    document.head.appendChild(style);
  });
})();
